import {mapState} from 'vuex';
import auctionBaseMixin from "@/mixins/auctionBaseMixin";
import moment from "moment";
import {getCurrentServerTime} from "@/helpers";

export default {
  mixins: [auctionBaseMixin],
  computed: {
    ...mapState(["auctionObject", "mainConfig"]),
    auction() {
      return this.auctionObject.data;
    },
    shouldShowStreambidIframe () {
      if (this.auction.type !== 'live') return false;

      let startDate = this.auction.start_date;

      let eventDate = typeof startDate === "string" ? moment(startDate).toDate().getTime() : startDate.getTime();
      startDate = moment(eventDate).utc();
      const currentTime = getCurrentServerTime()

      let difference = startDate - currentTime

      return difference <= this.mainConfig.streamingStartShowTime * 60 * 1000
    }
  }
}
